import { useMutation, useQueryClient } from '@tanstack/react-query';

import { axiosPrivate } from 'app/utils';

import { broadcastPropsUpdated } from '../../../../../../components/preview-messages';
import { markWebsiteAsChanged } from '../../../../../../hooks/usePlusWebsites';

interface CreateSectionParams {
  websiteId: string;
  pageId: string;
  sectionTypeId: string;
  version: number;
  data: Record<string, unknown>;
}

function createSection({ websiteId, pageId, ...body }: CreateSectionParams) {
  return axiosPrivate
    .post(`/v3/pharmacist/plus-websites/${websiteId}/pages/${pageId}/sections`, body)
    .then((r) => r.data);
}

export function useCreateSection() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createSection,
    onSuccess: (_data, { websiteId }) => {
      markWebsiteAsChanged(queryClient, websiteId);
      broadcastPropsUpdated();
    },
    meta: {
      successMessage: 'Section created successfully',
      errorMessage: 'Failed to create section',
    },
  });
}
